<template>
  <div
    class="fixed h-screen w-screen flex items-center justify-center flex-col gap-4"
  >
    <h2 class="text-6xl font-bold">404</h2>
    <p class="text-2xl font-bold">Page Not Found</p>
  </div>
</template>
